export default __webpack_public_path__ + "static/media/internal mic - active.644bae9d.svg";